/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import {Box, StandardTextFieldProps, TextField,} from '@mui/material';
import {withFormikField} from 'src/utils/formik';

export interface ZsTextFieldProps extends StandardTextFieldProps {
    label: string;
    errorText: string;
    disabled? : boolean;
}

export const ZsTextField: React.FC<ZsTextFieldProps> = ({
                                                                    label,
                                                                    errorText = '',
                                                                    ...props
                                                                }) => {
    window.addEventListener('mousewheel', (e: any) => {
        e.target.blur();
    });

    return (
        <Box style={{position: 'relative'}}>
            <TextField
                label={label}
                error={!!errorText}
                autoComplete='off'
                fullWidth
                hiddenLabel
                disabled={props.disabled}
                size="small"
                helperText={errorText}
                {...props}
            />
        </Box>
    );
};

const ZsFormikTextField = withFormikField(ZsTextField);

export default ZsFormikTextField;
